import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "../styles/links.css";
import HelmetTags from "../components/HelmetTags";
import Card from "../components/Card";

function Chapters() {
  const [solutions, setSolutions] = useState([]);
  const { type, class_name, subject } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get("https://cbselearn.onrender.com/soln")
      .then((response) => setSolutions(response.data.solns));
  }, []);

  return (
    <div className="page container">
      <HelmetTags
        title={`${type.replace(/-/g, " ").toUpperCase()} for  ${
          class_name.charAt(0).toUpperCase() +
          class_name.slice(1).replace(/-/g, " ")
        } ${
          subject.replace(/-/g, " ").charAt(0).toUpperCase() + subject.slice(1)
        }`}
        desc={`${type.replace(/-/g, " ").toUpperCase()} for ${
          class_name.charAt(0).toUpperCase() +
          class_name.slice(1).replace(/-/g, " ")
        } ${
          subject.replace(/-/g, " ").charAt(0).toUpperCase() + subject.slice(1)
        } solved by subject experts from latest edition books and as per NCERT (CBSE) guidelines.${
          class_name.charAt(0).toUpperCase() +
          class_name.slice(1).replace(/-/g, " ")
        } ${
          subject.replace(/-/g, " ").charAt(0).toUpperCase() + subject.slice(1)
        }  ${type
          .replace(/-/g, " ")
          .toUpperCase()} and Extra Questions with Solutions to help you to revise complete Syllabus and Score More marks.`}
        route={`${type}/${class_name}/${subject}`}
      />
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/">home</a>
          </li>
          <li class="breadcrumb-item">{type}</li>
          <li class="breadcrumb-item">{`${class_name}`}</li>
          <li
            class="breadcrumb-item active"
            aria-current="page"
          >{`${subject}`}</li>
        </ol>
      </nav>
      <Card
        title={type.replace(/-/g, " ").toUpperCase()}
        desc={`${type.replace(/-/g, " ").toUpperCase()} for
        ${
          class_name.charAt(0).toUpperCase() +
          class_name.slice(1).replace(/-/g, " ")
        }
        ${subject.replace(/-/g, " ").charAt(0).toUpperCase() + subject.slice(1)}
        solved by subject experts from latest edition books and as per NCERT
        (CBSE) guidelines.
        ${
          class_name.charAt(0).toUpperCase() +
          class_name.slice(1).replace(/-/g, " ")
        }
        ${subject.replace(/-/g, " ").charAt(0).toUpperCase() + subject.slice(1)}
        ${type.replace(/-/g, " ").toUpperCase()} and Extra Questions with
        Solutions to help you to revise complete Syllabus and Score More marks.`}
      />
      <h2>{}</h2>
      <p></p>
      <div className="links">
        <ul>
          {solutions.map((solution) => (
            <>
              {solution.type === type &&
              solution.class === class_name &&
              solution.subject === subject ? (
                <li>
                  {" "}
                  <Link
                    to={`/solutions/${solution.type}/${solution.class}/${
                      solution.subject
                    }/${solution.chapter.replace(/\s+/g, "-")}/${solution._id}`}
                  >
                    {solution.chapter}
                  </Link>
                </li>
              ) : null}
            </>
          ))}{" "}
        </ul>
      </div>
    </div>
  );
}

export default Chapters;